export class LanguageLink {
  href: string;
  title: string;

  constructor(href: string, title: string) {
    this.href = href;
    this.title = title;
  }
}
